
import { Button } from "@/components/ui/button";
import { RSVPButton } from "@/components/ui/rsvp-button";

interface EventFormActionsProps {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export const EventFormActions = ({
  onSave,
  onCancel,
  isSaving = false
}: EventFormActionsProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 pb-12 bg-gradient-to-t from-white via-white to-transparent">
      <div className="max-w-2xl mx-auto px-4 flex flex-col gap-3">
        <RSVPButton
          onClick={onSave}
          disabled={isSaving}
          className="mx-auto w-60 flex items-center justify-center gap-2 transform transition-transform duration-150"
        >
          {isSaving ? "Saving..." : "Save changes"}
        </RSVPButton>
        
        <Button 
          variant="outline" 
          onClick={onCancel} 
          className="mx-auto w-60 flex items-center justify-center"
        >
          Discard changes
        </Button>
      </div>
    </div>
  );
};
